module.exports = __webpack_public_path__ + "static/img/witness-kids-9.4af386f1.png";